<template>

  <mdb-container class="mt-2" v-if="showActiveSelections">

    <mdb-row>

      <mdb-col col="sm-12" class="active-selections">

        <h5 class="pt-3">{{ $t('general.previousSelection') }}</h5>

        <mdb-list-group>

          <mdb-list-group-item class="border-0 pl-0" v-if="configurator.eventType.hasOwnProperty('title') && ($route.name !== 'LandingPage'  || showAll )">
            <div>
              <span>{{ configurator.eventType.title }}</span>
              <router-link :to="{name: 'LandingPage'}" >
                <small class="text-muted">{{$t('general.change')}}</small>
              </router-link>
            </div>
          </mdb-list-group-item>


          <mdb-list-group-item class="border-0 pl-0" v-if="configurator.persons.count && ($route.name !== 'PersonDetails'  || showAll )">
            <span>{{ configurator.persons.count }} {{ configurator.persons.count === 1 ? $t('general.person') : $t('general.persons') }}</span>
            <router-link :to="{name: 'PersonDetails'}" >
              <small class="text-muted">{{$t('general.change')}}</small>
            </router-link>
          </mdb-list-group-item>


          <mdb-list-group-item class="border-0 pl-0" v-if="configurator.seatType.hasOwnProperty('title') && ($route.name !== 'SeatingType'  || showAll )">
            <span>{{ configurator.seatType.title }}</span>
            <router-link :to="{name: 'SeatingType'}" >
              <small class="text-muted">{{$t('general.change')}}</small>
            </router-link>
          </mdb-list-group-item>

          <mdb-list-group-item class="border-0 pl-0" :class="{'border-danger': !isAvailable}" v-if="configurator.duration.date_from && configurator.duration.date_to && configurator.duration.time_from && configurator.duration.time_to && ($route.name !== 'ScheduleDuration'  || showAll )">
            <span>{{ moment(configurator.duration.date_from).format('DD.MM') }} - {{moment(configurator.duration.date_to).format('DD.MM.YYYY')}} <br />
               <template v-if="$i18n.locale === 'de'">{{ configurator.duration.time_from }} - {{ configurator.duration.time_to }} {{ $t('general.clock') }}</template>
            <template v-else>{{ moment(configurator.duration.time_from, 'HH:mm').format('hh:mm A') }} - {{ moment(configurator.duration.time_to, 'HH:mm').format('hh:mm A') }}</template></span>
            <router-link :to="{name: 'ScheduleDuration'}" >
              <small class="text-muted">{{$t('general.change')}}</small>
            </router-link>
          </mdb-list-group-item>


          <mdb-list-group-item class="border-0 pl-0" v-if="configurator.inventories.filter(item=> item.count).length && ($route.name !== 'Inventory'  || showAll ) ">
            <div class="">
              <div class="font-weight-500" v-for="item in configurator.inventories.filter(item => item.count)" :key="item.id">{{ item.count }}x {{ item.title }}</div>
            </div>
            <router-link :to="{name: 'Inventory'}" >
              <small class="text-muted">{{$t('general.change')}}</small>
            </router-link>
          </mdb-list-group-item>

          <mdb-list-group-item class="border-0 pl-0" v-if="configurator.services.filter(item=> item.count).length && ($route.name !== 'Services'  || showAll )  ">
            <div class="">
              <div class="font-weight-500" v-for="item in configurator.services.filter(item => item.count)" :key="item.id">{{ item.count }}x {{ item.title }}</div>
            </div>
            <router-link :to="{name: 'Services'}" >
              <small class="text-muted">{{$t('general.change')}}</small>
            </router-link>
          </mdb-list-group-item>


          <mdb-list-group-item class="border-0 pl-0" v-if="configurator.additionalInfo.overNightStayOffer.id  && ($route.name !== 'AdditionalInfoOverNight'  || showAll )">
           <div>
             <span>{{ configurator.additionalInfo.overNightStayOffer.title }} : <br />{{ $t(`general.${configurator.additionalInfo.overNightStayOffer.value ? 'yes' : 'no'}`) }}</span>
             <router-link :to="{name: 'AdditionalInfoOverNight'}" >
               &emsp;<small class="text-muted">{{$t('general.change')}}</small>
             </router-link>
           </div>
          </mdb-list-group-item>

          <mdb-list-group-item class="border-0 pl-0" v-if="configurator.additionalInfo.otherWishes.id  && ($route.name !== 'AdditionalInfoOtherWishes'  || showAll )">
            <div>
              <span>{{ $t('additionalInfo.otherWishTitle') }} : <br /> {{ configurator.additionalInfo.otherWishes.value ? configurator.additionalInfo.otherWishes.value : '--'}}</span>
              <router-link :to="{name: 'AdditionalInfoOtherWishes'}" >
                &emsp;<small class="text-muted">{{$t('general.change')}}</small>
              </router-link>
            </div>
          </mdb-list-group-item>


        </mdb-list-group>

      </mdb-col>

    </mdb-row>

  </mdb-container>
</template>

<script>
import {mapGetters} from "vuex";

export default {

  name: "ActiveSelections",


  props: {
    showAll : {
      type: Boolean,
      required: false,
      default: false
    },
    isAvailable : {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data: () => {
    return {
      dateTimeFormat: 'YYYY-MM-DD hh:mm A'
    }
  },

  computed: {

    ...mapGetters({configurator: "getConfigurator"}),

    moment: () => moment,

    // Show active selections in certain pages
    showActiveSelections(){
      return [
          'PersonDetails',
          'SeatingType',
          'ScheduleDuration',
          'Inventory',
          'Services',
          'AdditionalInfo',
          'AdditionalInfoOverNight',
          'AdditionalInfoOtherWishes'
      ].includes(this.$route.name) || this.showAll;
    }
  }
}
</script>

<style lang="scss" scoped>
.active-selections{
  h5{
    font-weight: 400;
  }

  .list-group{
    .list-group-item{
      justify-content: flex-start !important;
      align-items: flex-end !important;
      gap: 10px;
      padding-top: 7px;
      padding-bottom: 7px;
      background-color: transparent;

      //display: flex;

      span{
        font-weight: 500;
      }

      span, div{
        word-break: break-all;
      }
    }
  }
}
@for $i from 1 through 9 {
  $v: $i * 100;
  .font-weight-#{$v} {
    font-weight: $v;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/ActiveSelections.vue